export function utilData(monthFilter: string) {
  const [year, month] = monthFilter.split('/').map(Number)
  const firstDayNextMonth = new Date(year, month, 1)
  const lastDayCurrentMonth = new Date(firstDayNextMonth.getTime() - 1)
  const date_end = `${lastDayCurrentMonth.getFullYear()}/${(
    '0' +
    (lastDayCurrentMonth.getMonth() + 1)
  ).slice(-2)}/${('0' + lastDayCurrentMonth.getDate()).slice(-2)}`

  return date_end
}
